import React from "react";
import * as agent from "../agent";
import { connect } from "react-redux";
import { formValueSelector, reduxForm, Field, reset } from "redux-form";
import { MESSAGE_SENDED } from "../constants/actionTypes";
import { validatePhone, validateEmail, required, formatPhone } from "../utility";
import { Transaction, Masks } from "../constants/enums";
import { MaterialTextField, MaterialMaskedTextField, MaterialCheckbox } from "./MaterialInput";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import SubmitButton from './SubmitButton';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Preloader from './Preloader';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import EditIcon from '@material-ui/icons/Edit';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const companyForm = ({ onAddCompany, handleSubmit }) => (
    <form className="common-form common-column" onSubmit={handleSubmit(data => onAddCompany(data))} >
        <Field component={MaterialTextField}
               validate={required}
               name="name"
               label="Компания" />
        <SubmitButton label="Добавить" />
    </form>
);

const CompanyForm = reduxForm({form: "company-form", onSubmitSuccess: (result, dispatch) => dispatch(reset("company-form")) })(companyForm);

const accountForm = ({ onAddAccount, companies, companiesLoaded, godmode, handleSubmit }) => (
    <form className="common-form common-column" onSubmit={handleSubmit(data => onAddAccount(data))} >
        <Field component={MaterialTextField}
               validate={required}
               name="name"
               label="Наименование счета" />
        <Field name="company"
               select
               disabled={!companiesLoaded}
               validate={required}
               component={MaterialTextField}
               label="Компания" >
            {companies.map(({ _id, name }, i) => <MenuItem key={i} value={_id}>{name}</MenuItem>)}
        </Field>
        <Field name="number"
               disabled={!companiesLoaded}
               validate={required}
               mask={Masks.account}
               component={MaterialMaskedTextField}
               label="Номер" >
        </Field>
        {godmode &&
            <FormControlLabel
                control={ <Field name="isBlack" component={MaterialCheckbox} /> }
                label="Черный нал" />
        }
        <SubmitButton label="Добавить" />
    </form>
);

const AccountForm = reduxForm({form: "account-form", onSubmitSuccess: (result, dispatch) => dispatch(reset("account-form")) })(accountForm);

const counterpartyForm = ({ inputCounterpartyType, onAddCounterparty, handleSubmit }) => (
    <form className="common-form common-column" onSubmit={handleSubmit(data => onAddCounterparty(data))} >
        <Field component={MaterialTextField}
               validate={required}
               name="name"
               label="Контрагент" />
        <Field name="type"
               select
               validate={required}
               component={MaterialTextField}
               label="Тип" >
            {Object.keys(Transaction.CounterpartyTypes).map((ct, i) => <MenuItem key={i} value={ct}>{Transaction.CounterpartyTypes[ct]}</MenuItem>)}
        </Field>
        <Field name="phone"
               component={MaterialMaskedTextField}
               mask={Masks.phone}
               validate={validatePhone}
               placeholder="+7 (___) ___-__-__"
               label="Номер телефона" />
        {["JURIDICAL_PERSON", "SP"].includes(inputCounterpartyType) &&
            <Field component={MaterialTextField}
                   validate={required}
                   name="inn"
                   label="ИНН" />
        }
        {["JURIDICAL_PERSON", "SP"].includes(inputCounterpartyType) &&
            <Field component={MaterialTextField}
                   validate={required}
                   name="ogrn"
                   label="ОГРН" />
        }
        {["NATURAL_PERSON", "SP", "EMPLOYEE"].includes(inputCounterpartyType) &&
            <Field name="passport.serie"
                   validate={required}
                   component={MaterialMaskedTextField}
                   mask={Masks.passportSerie}
                   label="Серия паспорта" />
        }
        {["NATURAL_PERSON", "SP", "EMPLOYEE"].includes(inputCounterpartyType) &&
            <Field name="passport.number"
                   component={MaterialMaskedTextField}
                   validate={required}
                   mask={Masks.passportNumber}
                   label="Номер паспорта" />
        }
        {["NATURAL_PERSON", "SP", "EMPLOYEE"].includes(inputCounterpartyType) &&
            <Field name="passport.date"
                   component={MaterialMaskedTextField}
                   validate={required}
                   mask={Masks.date}
                   label="Дата выдачи паспорта" />
        }
        <Field component={MaterialTextField}
               name="email"
               validate={validateEmail}
               label="Электронный адрес" />
        <Field component={MaterialTextField}
               name="address"
               multiline
               rows={2}
               validate={required}
               label="Адрес" />
        <SubmitButton label="Добавить" />
    </form>
);

const CounterpartyForm = reduxForm({form: "counterparty-form", onSubmitSuccess: (result, dispatch) => dispatch(reset("counterparty-form")) })(counterpartyForm);

const operationForm = ({ godmode, inputGroup, operationGroups, operationSubgroups, onAddOperation, handleSubmit }) => (
    <form className="common-form common-column" onSubmit={handleSubmit(data => onAddOperation(data))} >
        <Field component={MaterialTextField}
               validate={required}
               name="name"
               label="Статья ДДС" />
        <Field name="group"
               select
               validate={required}
               component={MaterialTextField}
               label="Группа статей" >
            {operationGroups.map(({name, _id}, i) => <MenuItem key={i} value={_id}>{name}</MenuItem>)}
        </Field>
        <Field name="subgroup"
               select
               disabled={operationSubgroups.filter(({ group }) => group ? group._id === inputGroup : true ).length < 1}
               component={MaterialTextField}
               label="Подгруппа статей" >
            {operationSubgroups.filter(({ group }) => group ? group._id === inputGroup : true ).map(({name, _id}, i) => <MenuItem key={i} value={_id}>{name}</MenuItem>)}
        </Field>
        <Field name="side"
               select
               component={MaterialTextField}
               label="Тип" >
            {Object.keys(Transaction.OperationSides).map((s, i) => <MenuItem key={i} value={s}>{Transaction.OperationSides[s]}</MenuItem>)}
        </Field>
        {godmode &&
            <Field name="alias"
                   component={MaterialTextField}
                   label="alias" />
        }
        {godmode &&
            <FormControlLabel
                control={ <Field name="editable" component={MaterialCheckbox} /> }
                label="Пользовательская" />
        }
        <FormControlLabel
            control={ <Field name="mustHaveContract" component={MaterialCheckbox} /> }
            label="Должна включать Договор" />
        <FormControlLabel
            control={ <Field name="mustHaveCredit" component={MaterialCheckbox} /> }
            label="Должна включать Кредит" />
        <FormControlLabel
            control={ <Field name="mustHaveDepartment" component={MaterialCheckbox} /> }
            label="Должна включать Подразделение" />
        <SubmitButton label="Добавить" />
    </form>
);

const OperationForm = reduxForm({
    form: "operation-form",
    enableReinitialize: true,
    // onSubmitSuccess: (result, dispatch) => dispatch(reset("operation-form"))
})(operationForm);


const editOperationForm = ({ inputGroup, operationGroups, operationSubgroups, onEditOperation, handleSubmit }) => (
    <form className="common-form common-column" onSubmit={handleSubmit(data => onEditOperation(data))} >
        <Field component={MaterialTextField}
               validate={required}
               name="name"
               label="Статья ДДС" />
        <Field name="group"
               select
               validate={required}
               component={MaterialTextField}
               label="Группа статей" >
            {operationGroups.map(({name, _id}, i) => <MenuItem key={i} value={_id}>{name}</MenuItem>)}
        </Field>
        <Field name="subgroup"
               select
               disabled={operationSubgroups.filter(({ group }) => group ? group._id === inputGroup : true ).length < 1}
               component={MaterialTextField}
               label="Подгруппа статей" >
            {operationSubgroups.filter(({ group }) => group ? group._id === inputGroup : true ).map(({name, _id}, i) => <MenuItem key={i} value={_id}>{name}</MenuItem>)}
        </Field>
        <Field name="side"
               select
               component={MaterialTextField}
               label="Тип" >
            {Object.keys(Transaction.OperationSides).map((s, i) => <MenuItem key={i} value={s}>{Transaction.OperationSides[s]}</MenuItem>)}
        </Field>
        <FormControlLabel
            control={ <Field name="mustHaveContract" component={MaterialCheckbox} /> }
            label="Должна включать Договор" />
        <FormControlLabel
            control={ <Field name="mustHaveCredit" component={MaterialCheckbox} /> }
            label="Должна включать Кредит" />
        <FormControlLabel
            control={ <Field name="mustHaveDepartment" component={MaterialCheckbox} /> }
            label="Должна включать Подразделение" />
        <SubmitButton label="Сохранить" />
    </form>
);

const EditOperationForm = connect(
    (state, props) => {
        const inputGroup = formValueSelector("edit-operation-form")(state, "group");
        const { operations, editedOperationId } = props;
        const foundOperation = operations.find(o => o._id === editedOperationId);
        const { group = {}, subgroup = {} } = foundOperation;
        return {
            inputGroup,
            initialValues: Object.assign({}, foundOperation, {group: group._id, subgroup: subgroup._id}),
        };
    }
)(reduxForm({ form: "edit-operation-form", enableReinitialize: true })(editOperationForm));

const operationGroupForm = ({ onAddOperationGroup, handleSubmit }) => (
    <form className="common-form common-column" onSubmit={handleSubmit(data => onAddOperationGroup(data))} >
         <Field component={MaterialTextField}
                validate={required}
                name="name"
                label="Группа статей" />
         <SubmitButton label="Добавить" />
    </form>
);

const OperationGroupForm = reduxForm({form: "operation-group-form", onSubmitSuccess: (result, dispatch) => dispatch(reset("operation-group-form")) })(operationGroupForm);


const operationSubgroupForm = ({ operationGroups = [], onAddOperationSubgroup, handleSubmit }) => (
    <form className="common-form common-column" onSubmit={handleSubmit(data => onAddOperationSubgroup(data))} >
        <Field name="group"
               select
               validate={required}
               component={MaterialTextField}
               label="Группа статей" >
            {operationGroups.map(({name, _id}, i) => <MenuItem key={i} value={_id}>{name}</MenuItem>)}
        </Field>
        <Field component={MaterialTextField}
               validate={required}
               name="name"
               label="Подгруппа статей" />
        <SubmitButton label="Добавить" />
    </form>
);

const OperationSubgroupForm = reduxForm({form: "operation-subgroup-form", onSubmitSuccess: (result, dispatch) => dispatch(reset("operation-subgroup-form")) })(operationSubgroupForm);

class BookkeepingCRUD extends React.Component {

    state = {
        accounts: [],
        accountsLoaded: false,
        counterparties: [],
        counterpartiesLoaded: false,
        companies: [],
        companiesLoaded: false,
        operations: [],
        operationsLoaded: false,
        operationGroups: [],
        operationGroupsLoaded: false,
        operationSubgroups: [],
        operationSubgroupsLoaded: false,
        showEditModal: false
    };
    fireError = e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } });
    fetchAccounts = () => {
        if(!this.state.accountsLoaded) {
            agent.Account.getAll()
                .then(res => this.setState({ accountsLoaded: true, accounts: res }))
                .catch(this.fireError);
        }
    }
    fetchCompanies = () => {
        if(!this.state.companiesLoaded) {
            agent.Company.getAll()
                .then(res => this.setState({ companiesLoaded: true, companies: res }))
                .catch(this.fireError);
        }
    }
    fetchCounterparties = () => {
        if(!this.state.counterpartiesLoaded) {
            agent.Counterparty.getAll()
                .then(res => this.setState({ counterpartiesLoaded: true, counterparties: res }))
                .catch(this.fireError);
        }
    }
    fetchOperations = () => {
        if(!this.state.operationsLoaded) {
            agent.Operation.getAll()
                .then(res => this.setState({ operationsLoaded: true, operations: res }))
                .catch(this.fireError);
        }
    }
    fetchOperationGroups = () => {
        if(!this.state.operationGroupsLoaded) {
            agent.OperationGroup.getAll()
                .then(res => this.setState({ operationGroupsLoaded: true, operationGroups: res }))
                .catch(this.fireError);
        }
    }
    fetchOperationSubgroups = () => {
        if(!this.state.operationSubgroupsLoaded) {
            agent.OperationSubgroup.getAll()
                .then(res => this.setState({ operationSubgroupsLoaded: true, operationSubgroups: res }))
                .catch(this.fireError);
        }
    }
    addAccount = (data) => {
        this.setState({ accountsLoaded: false });
        agent.Account.create(data)
            .then(() => this.fetchAccounts())
            .then(() => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: "Добавлено", type: "success" } }))
            .catch(this.fireError);
    }
    addCompany = (data) => {
        this.setState({ companiesLoaded: false });
        agent.Company.create(data)
            .then(() => this.fetchCompanies())
            .then(() => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: "Добавлено", type: "success" } }))
            .catch(this.fireError);
    }
    addCounterparty = (data) => {
        this.setState({ counterpartiesLoaded: false });
        agent.Counterparty.create(data)
            .then(() => this.fetchCounterparties())
            .then(() => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: "Добавлено", type: "success" } }))
            .catch(this.fireError);
    }
    addOperation = (data) => {
        this.setState({ operationsLoaded: false });
        agent.Operation.create(data)
            .then(() => this.fetchOperations())
            .then(() => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: "Добавлено", type: "success" } }))
            .catch(this.fireError);
    }
    addOperationGroup = (data) => {
        this.setState({ operationGroupsLoaded: false });
        agent.OperationGroup.create(data)
            .then(() => this.fetchOperationGroups())
            .then(() => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: "Добавлено", type: "success" } }))
            .catch(this.fireError);
    }
    addOperationSubgroup = (data) => {
        this.setState({ operationSubgroupsLoaded: false });
        agent.OperationSubgroup.create(data)
            .then(() => this.fetchOperationSubgroups())
            .then(() => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: "Добавлено", type: "success" } }))
            .catch(this.fireError);
    }
    deleteAccount = id => {
        this.setState({ accountsLoaded: false });
        agent.Account.delete(id)
            .then(() => this.fetchAccounts())
            .then(() => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: "Удалено", type: "success" } }))
            .catch(this.fireError);
    }
    deleteCompany = id => {
        this.setState({ companiesLoaded: false });
        agent.Company.delete(id)
            .then(() => this.fetchCompanies())
            .then(() => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: "Удалено", type: "success" } }))
            .catch(this.fireError);
    }
    deleteCounterparty = id => {
        this.setState({ counterpartiesLoaded: false });
        agent.Counterparty.delete(id)
            .then(() => this.fetchCounterparties())
            .then(() => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: "Удалено", type: "success" } }))
            .catch(this.fireError);
    }
    deleteOperationSubgroup = id => {
        this.setState({ operationSubgroupsLoaded: false });
        agent.OperationSubgroup.delete(id)
            .then(() => {this.fetchOperationSubgroups(); this.fetchOperations()})
            .then(() => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: "Удалено", type: "success" } }))
            .catch(this.fireError);
    }
    deleteOperationGroup = id => {
        this.setState({ operationGroupsLoaded: false });
        agent.OperationGroup.delete(id)
            .then(() => this.componentDidMount())
            .then(() => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: "Удалено", type: "success" } }))
            .catch(this.fireError);
    }
    deleteOperation = id => {
        this.setState({ operationsLoaded: false });
        agent.Operation.delete(id)
            .then(() => this.fetchOperations())
            .then(() => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: "Удалено", type: "success" } }))
            .catch(this.fireError);
    }
    editOperation = (data) => {
        this.setState({ operationsLoaded: false });
        const { operations, editedOperationId } = this.state;
        agent.Operation.edit(editedOperationId, data)
            .then(res => this.setState({ operations: operations.map(o => o._id === editedOperationId ? res : o), operationsLoaded: true, showEditModal: false }))
            .then(() => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: "Операция отредактирована", type: "success" } }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }
    handleEditOpen = (e, id) => {
        e.preventDefault();
        this.setState({ showEditModal: true, editedOperationId: id });
    }
    handleEditClose = () => this.setState({ showEditModal: false});

    render() {
        const { accounts,
                accountsLoaded,
                counterparties,
                counterpartiesLoaded,
                companies,
                companiesLoaded,
                operations,
                operationsLoaded,
                operationGroups,
                operationGroupsLoaded,
                operationSubgroups,
                operationSubgroupsLoaded,
                showEditModal,
                editedOperationId } = this.state;
        const { inputGroup, inputCounterpartyType } = this.props;
        const godmode = (window.location.search || "").split("?").includes("root");
        return (
            <div style={{ padding: 5 }}>
                <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} onClick={this.fetchCompanies}>
                        <Typography variant="h5">Компании</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Grid container justify="flex-start" spacing={16}>
                            <Grid item>
                                <CompanyForm onAddCompany={this.addCompany} />
                            </Grid>
                            <Grid item>
                                {companiesLoaded ?
                                    companies.length > 0 ?
                                        <Table padding="checkbox">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Компания</TableCell>
                                                    {godmode && <TableCell padding="none">&nbsp;</TableCell>}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                            {companies.map(({ name, _id }, i) => {
                                                return (
                                                    <TableRow key={i} >
                                                        <TableCell>{ name }</TableCell>
                                                        {godmode &&
                                                            <TableCell padding="none">
                                                                <IconButton onClick={() => this.deleteCompany(_id)}>
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                        }
                                                    </TableRow>
                                                )}
                                            )}
                                            </TableBody>
                                        </Table>
                                        :
                                        <Typography paragraph>Компании еще не добавлены</Typography>
                                    : <Preloader />
                                }
                            </Grid>
                        </Grid>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} onClick={() => {this.fetchAccounts(); this.fetchCompanies(); }}>
                        <Typography variant="h5">Учетные счета</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Grid container justify="flex-start" spacing={16}>
                            <Grid item>
                                <AccountForm companies={companies}
                                             companiesLoaded={companiesLoaded}
                                             onAddAccount={this.addAccount}
                                             godmode={godmode} />
                            </Grid>
                            <Grid item>
                                {accountsLoaded ?
                                    accounts.length > 0 ?
                                        <Table padding="checkbox">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Счет</TableCell>
                                                    <TableCell>Компания</TableCell>
                                                    <TableCell>Номер</TableCell>
                                                    {godmode && <TableCell>Тип</TableCell>}
                                                    {godmode && <TableCell padding="none">&nbsp;</TableCell>}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                            {accounts.map(({ name, company = {}, number, isBlack, _id }, i) => {
                                                return (
                                                    <TableRow key={i} >
                                                        <TableCell>{ name }</TableCell>
                                                        <TableCell>{ company.name }</TableCell>
                                                        <TableCell>{ number }</TableCell>
                                                        {godmode && <TableCell>{ isBlack ? "Черный нал" : "Белый нал" }</TableCell>}
                                                        {godmode &&
                                                            <TableCell padding="none">
                                                                <IconButton onClick={() => this.deleteAccount(_id)}>
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                        }
                                                    </TableRow>
                                                )}
                                            )}
                                            </TableBody>
                                        </Table>
                                        :
                                        <Typography paragraph>Учетные счета еще не добавлены</Typography>
                                    : <Preloader />
                                }
                            </Grid>
                        </Grid>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} onClick={this.fetchCounterparties}>
                        <Typography variant="h5">Контрагенты</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Grid container justify="flex-start" spacing={16}>
                            <Grid item>
                                <CounterpartyForm inputCounterpartyType={inputCounterpartyType}
                                                  onAddCounterparty={this.addCounterparty} />
                            </Grid>
                            <Grid item xs>
                                {counterpartiesLoaded ?
                                    counterparties.length > 0 ?
                                        <Table padding="checkbox">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Контрагент</TableCell>
                                                    <TableCell>Тип</TableCell>
                                                    <TableCell>Телефон</TableCell>
                                                    <TableCell>Паспортные данные</TableCell>
                                                    <TableCell>ИНН</TableCell>
                                                    <TableCell>ОГРН</TableCell>
                                                    <TableCell>Электронный адрес</TableCell>
                                                    <TableCell>Адрес</TableCell>
                                                    {godmode && <TableCell padding="none">&nbsp;</TableCell>}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                            {counterparties.map(({ name, type, inn, ogrn, phone, email, address, passport, _id }, i) => {
                                                return (
                                                    <TableRow key={i} >
                                                        <TableCell>{ name }</TableCell>
                                                        <TableCell>{ Transaction.CounterpartyTypes[type] }</TableCell>
                                                        <TableCell>{ formatPhone(phone) }</TableCell>
                                                        <TableCell>{ passport ? `${passport.serie} ${passport.number} выдан ${passport.date}` : "—" }</TableCell>
                                                        <TableCell>{ inn || "—" }</TableCell>
                                                        <TableCell>{ ogrn || "—" }</TableCell>
                                                        <TableCell>{ email }</TableCell>
                                                        <TableCell>{ address }</TableCell>
                                                        {godmode &&
                                                            <TableCell padding="none">
                                                                <IconButton onClick={() => this.deleteCounterparty(_id)}>
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                        }
                                                    </TableRow>
                                                )}
                                            )}
                                            </TableBody>
                                        </Table>
                                        :
                                        <Typography paragraph>Контрагенты еще не добавлены</Typography>
                                    : <Preloader />
                                }
                            </Grid>
                        </Grid>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} onClick={this.fetchOperationGroups}>
                        <Typography variant="h5">Группы статей</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Grid container justify="flex-start" spacing={16}>
                            <Grid item>
                                <OperationGroupForm onAddOperationGroup={this.addOperationGroup} />
                            </Grid>
                            <Grid item>
                                {operationGroupsLoaded ?
                                    operationGroups.length > 0 ?
                                        <Table padding="checkbox">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Группа</TableCell>
                                                    {godmode && <TableCell padding="none">&nbsp;</TableCell>}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                            {operationGroups.map(({ name, _id }, i) => {
                                                return (
                                                    <TableRow key={i} >
                                                        <TableCell>{ name }</TableCell>
                                                        {godmode &&
                                                            <TableCell padding="none">
                                                                <IconButton onClick={() => this.deleteOperationGroup(_id)}>
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                        }
                                                    </TableRow>
                                                )}
                                            )}
                                            </TableBody>
                                        </Table>
                                        :
                                        <Typography paragraph>Группы статей еще не добавлены</Typography>
                                    : <Preloader />
                                }
                            </Grid>
                        </Grid>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} onClick={() => {this.fetchOperationSubgroups(); this.fetchOperationGroups()}}>
                        <Typography variant="h5">Подгруппы статей</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Grid container justify="flex-start" spacing={16}>
                            <Grid item>
                                <OperationSubgroupForm onAddOperationSubgroup={this.addOperationSubgroup}
                                                       operationGroups={operationGroups} />
                           </Grid>
                           <Grid item>
                                {operationSubgroupsLoaded ?
                                    operationSubgroups.length > 0 ?
                                        <Table padding="checkbox">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Подгруппа</TableCell>
                                                    <TableCell>Группа</TableCell>
                                                    {godmode && <TableCell padding="none">&nbsp;</TableCell>}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {operationSubgroups.map(({ name, group = {}, _id }, i) => {
                                                    return (
                                                        <TableRow key={i} >
                                                            <TableCell>{ name }</TableCell>
                                                            <TableCell>{ group ? group.name : "—" }</TableCell>
                                                            {godmode &&
                                                                <TableCell padding="none">
                                                                    <IconButton onClick={() => this.deleteOperationSubgroup(_id)}>
                                                                        <DeleteIcon />
                                                                    </IconButton>
                                                                </TableCell>
                                                            }
                                                        </TableRow>
                                                    )}
                                                )}
                                            </TableBody>
                                        </Table>
                                        :
                                        <Typography paragraph>Подгруппы статей еще не добавлены</Typography>
                                    : <Preloader />
                                }
                            </Grid>
                        </Grid>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} onClick={() => {this.fetchOperations(); this.fetchOperationSubgroups(); this.fetchOperationGroups()}}>
                        <Typography variant="h5">Статьи ДДС</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <Grid container justify="flex-start" spacing={16}>
                            <Grid item>
                                <OperationForm onAddOperation={this.addOperation}
                                               godmode={godmode}
                                               operationGroups={operationGroups}
                                               operationSubgroups={operationSubgroups}
                                               inputGroup={inputGroup} />
                            </Grid>
                            <Grid item xs>
                                {operationsLoaded ?
                                    operations.length > 0 ?
                                        <Table padding="checkbox">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Статья ДДС</TableCell>
                                                    <TableCell>Тип</TableCell>
                                                    <TableCell>Группа</TableCell>
                                                    <TableCell>Подгруппа</TableCell>
                                                    <TableCell>Договор</TableCell>
                                                    <TableCell>Кредит</TableCell>
                                                    <TableCell>Подразделение</TableCell>
                                                    {godmode && <TableCell padding="none">&nbsp;</TableCell>}
                                                    {godmode && <TableCell padding="none">&nbsp;</TableCell>}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {operations.map(({ name,
                                                                   group = {},
                                                                   subgroup = {},
                                                                   side,
                                                                   source,
                                                                   mustHaveContract,
                                                                   mustHaveCredit,
                                                                   mustHaveDepartment,
                                                                   alias,
                                                                   editable,
                                                                   _id }, i) => {
                                                    return (
                                                        <TableRow key={i} >
                                                            <TableCell>{ name }</TableCell>
                                                            <TableCell>{ Transaction.OperationSides[side] }</TableCell>
                                                            <TableCell>{ group ? group.name : "—" }</TableCell>
                                                            <TableCell>{ subgroup ? subgroup.name : "—" }</TableCell>
                                                            <TableCell>{mustHaveContract ? "да" : "нет"}</TableCell>
                                                            <TableCell>{mustHaveCredit ? "да" : "нет"}</TableCell>
                                                            <TableCell>{mustHaveDepartment ? "да" : "нет"}</TableCell>
                                                            {godmode &&
                                                                <TableCell padding="none">
                                                                    <IconButton onClick={(e) => this.handleEditOpen(e, _id)}>
                                                                        <EditIcon fontSize="small" />
                                                                    </IconButton>
                                                                </TableCell>
                                                            }
                                                            {godmode &&
                                                                <TableCell padding="none">
                                                                    {editable &&
                                                                        <IconButton onClick={() => this.deleteOperation(_id)}>
                                                                            <DeleteIcon />
                                                                        </IconButton>
                                                                    }
                                                                </TableCell>
                                                            }
                                                        </TableRow>
                                                    )}
                                                )}
                                            </TableBody>
                                        </Table>
                                        :
                                        <Typography paragraph>Статьи ДДС еще не добавлены</Typography>
                                    : <Preloader />
                                }
                            </Grid>
                        </Grid>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                {showEditModal &&
                    <Dialog maxWidth={false} open={showEditModal} onClose={this.handleEditClose}>
                        <Paper className="common-paper">
                            <EditOperationForm operationGroups={operationGroups}
                                               operationSubgroups={operationSubgroups}
                                               operations={operations}
                                               editedOperationId={editedOperationId}
                                               onEditOperation={this.editOperation} />
                        </Paper>
                    </Dialog>
                }
            </div>
        )
    }
}

const mapStateToProps = state => ({
    inputGroup: formValueSelector("operation-form")(state, "group"),
    inputCounterpartyType: formValueSelector("counterparty-form")(state, "type")
});

export default connect(mapStateToProps, null)(BookkeepingCRUD);



// WEBPACK FOOTER //
// ./src/components/BookkeepingCRUD.js